// 测试环境服务器地址
export const devApiUrl = "http://api-2.laoniuche.cn";
// 生产环境服务器地址
export const proApiUrl = "https://api-2.yunhaogroup.com";